module.exports = __webpack_public_path__ + "static/img/exhibitFormTips8.4a472db0.png";